import React from "react";
import { statusBadgeClass, STATUS_LABELS } from "@/lib/format";

export function StatusBadge({ status }) {
    return (
        <span className={statusBadgeClass(status)} data-testid={`status-badge-${status}`}>
            <span className={`h-1.5 w-1.5 rounded-full bg-current opacity-80`} />
            {STATUS_LABELS[status] || status}
        </span>
    );
}

export function ScorePill({ score }) {
    let s = "neutral";
    if (score <= 20) s = "critico";
    else if (score <= 50) s = "atencao";
    else if (score < 70) s = "saudavel";  // M6 — Score >= 70 = Excelente
    else s = "excelente";
    return (
        <div className="flex items-baseline gap-2">
            <span className={`font-mono-tab font-semibold text-2xl text-[#0F2044]`}>{score}</span>
            <StatusBadge status={s} />
        </div>
    );
}

export function KpiCard({ label, value, hint, accent, testid, onClick }) {
    const clickable = typeof onClick === "function";
    const Comp = clickable ? "button" : "div";
    return (
        <Comp onClick={onClick}
            className={`bg-white border border-slate-200 rounded-lg p-5 shadow-sm text-left w-full ${clickable ? "cursor-pointer hover:border-slate-300 hover:shadow transition-all" : ""}`}
            data-testid={testid}>
            <div className="text-xs uppercase tracking-[0.18em] text-slate-500 font-medium">{label}</div>
            <div className="mt-2 flex items-baseline gap-2">
                <div className="text-4xl font-display font-semibold tracking-tight text-[#0F2044]">{value}</div>
                {accent && <div className="text-sm font-medium" style={{ color: accent.color }}>{accent.label}</div>}
            </div>
            {hint && <div className="text-xs text-slate-500 mt-1">{hint}</div>}
        </Comp>
    );
}
